<template>
  <div class="realtimeData">
    <div class="search-box padding-left" style="margin-bottom: 0px !important">
      <div class="search-item" style="margin-bottom: 14px !important">
        <span class="title">决策模型：</span>
        <el-select @change="ChangeDecisionId" v-model="decisionId" clearable placeholder="请选择">
          <el-option v-for="item in ModelDecision" :key="item.id" :label="item.groupName" :value="item.id"> </el-option>
        </el-select>
      </div>
      <div class="search-item" style="margin-bottom: 14px !important">
        <span class="title">设备名称：</span>
        <el-select v-model="eid" filterable placeholder="请选择设备名称" class="mg_right1 centerfont" maxlength="50" @change="serchKey">
          <el-option :label="item.name" :value="item.id" v-for="(item, index) in deviceList" :key="index">
            <el-popover placement="top-start" width="225" open-delay="1000" trigger="hover" :content="item.name" v-if="item.name.length > 12">
              <span slot="reference" class="limitoption">{{ item.name }}</span>
            </el-popover>
            <span class="limitoption" v-else>{{ item.name }}</span>
          </el-option>
        </el-select>
      </div>

      <div class="search-item" style="margin-bottom: 14px !important">
        <span class="title">属性名称：</span>
        <el-select v-model="attributeId" filterable placeholder="请选择属性名称" class="mg_right1 centerfont" maxlength="50" @change="serchKey">
          <el-option :label="item.name" :value="item.id" v-for="(item, index) in attrList" :key="index">
            <el-popover placement="top-start" width="225" open-delay="1000" trigger="hover" :content="item.name" v-if="item.name.length > 12">
              <span slot="reference" class="limitoption">{{ item.name }}</span>
            </el-popover>
            <span class="limitoption" v-else>{{ item.name }}</span>
          </el-option>
        </el-select>
      </div>
      <div class="search-item" style="margin-bottom: 14px !important">
        <el-button type="primary" @click="showbox" icon="el-icon-date" style="margin-right: 20px">日期选择</el-button>
        <!-- <el-date-picker class="mg_right1" v-model="dateRange" type="datetimerange" align="right" :default-value="timeDefaultShow" unlink-panels range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"  :default-time="['00:00:00', '23:59:590']">
        </el-date-picker> -->
      </div>
      <div class="search-item" style="margin-bottom: 14px !important">
        <el-button type="primary" @click="serchKey" class="search_btn">查 询</el-button>
      </div>
    </div>

    <div class="realtimeDataChart">
      <div id="myChart7" style="width: 100%; height: 100%; display: inline-block"></div>
    </div>
    <el-dialog :close-on-click-modal="false" title="选择环比时间段" :visible.sync="dialogVisible" width="780px" :before-close="handleClose">
      <div class="equipmentcenter-opption-box">
        <el-form ref="ruleForm" :rules="rules" :model="form" label-width="140px">
          <ul v-for="(form, index) in form" :key="index">
            <el-form-item :label="`时间段${index + 1}：`" prop="cname">
              <el-date-picker class="mg_right1" v-model="form.dateRange" type="datetimerange" align="right" :default-value="timeDefaultShow" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" :default-time="['00:00:00', '23:59:590']"> </el-date-picker>
              <a class="sc-btn2" @click="del(index)">删除</a>
            </el-form-item>
          </ul>
          <el-form-item>
            <a class="td-opption" @click="add()">+添加字段</a>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import store from '@/store/index'
// import echarts from 'echarts'

export default {
  name: 'realtimeData',
  components: {},
  props: {
    ModelDecision: ''
  },
  data() {
    return {
      decisionId: '',
      dialogVisible: false,
      form: [
        {
          dateRange: ''
        }
      ],
      usertypeshow: '',
      dateType: '0',
      active: '1',

      deviceType: '',
      timeDefaultShow: '',
      dateRange: '',
      groupId: '',
      mode: '1',
      gettera: '1',
      eid: '',
      attributeId: '',
      groupList: [],
      tablelist: [],
      tableData: []
    }
  },
  computed: {},
  filters: {},
  methods: {
    showbox() {
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    add: function () {
      let cope = { dateRange: '' }
      this.form.push(cope)
    },
    del: function (index) {
      this.form.splice(index, 1)
    },
    filteremojifun(e, name, ruleForm) {
      //过滤表情
      this.$utils.filteremojifun(this, e, name, ruleForm)
    },
    reset() {
      this.dateRange = ''
      this.getDataCollectStatisticChart()
    },
    serchKey() {
      this.currentPage = '1'
      this.getDataCollectStatisticChart()
    },
    selecType(e) {
      this.active = e
    },
    selecType2(e) {
      this.gettera = e
      this.mode = e
      if (e == 0) {
        var datee = new Date()
        var year = datee.getFullYear()
        var month = datee.getMonth()
        var day = datee.getDate()
        var hours = datee.getHours()
        var hours2 = datee.getHours() + 1
        this.dateRange = [new Date(year, month, day, hours, 0, 0), new Date(year, month, day, hours2, 0, 0)]
      } else {
        this.getNowdate()
      }
      this.serchKey()
    },

    getDevicesByGroupId(id) {
      //获取分组对应的设备
      let a = ''
      this.ModelDecision.map(item => {
        if (item.id == this.decisionId) {
          a = item.groupId
        }
      })
      this.$api.device.getNumericalsByGroupId({ groupId: a }).then(res => {
        if (res.code == 200) {
          //this.deviceList = res.data

          if (res.data.length > 0) {
            this.deviceList = []

            for (var i = 0; i < res.data.length; i++) {
              var obj = {}
              if (res.data[i].name == undefined) {
                res.data[i].name = '未命名'
              }
              obj.name = res.data[i].name
              obj.id = res.data[i].id
              this.deviceList.push(obj)
            }
            this.eid = res.data[0].id
          } else {
            this.deviceList = []
            this.eid = ''
          }
        }
        this.$forceUpdate()
      })
    },
    getRealDatasByEid(id) {
      //获取分组对应的设备
      if (id == '' || id == undefined) {
        return false
      }
      this.$api.device.getAttributesByEid(id).then(res => {
        if (res.code == 200) {
          //this.deviceList = res.data
          if (res.data.length > 0) {
            this.attrList = []
            for (var i = 0; i < res.data.length; i++) {
              var obj = {}
              obj.name = res.data[i].cname
              obj.id = res.data[i].id
              this.attrList.push(obj)
            }
            this.attributeId = res.data[0].id
          } else {
            this.attrList = []
            this.attributeId = ''
          }
        }
        this.$forceUpdate()
      })
    },

    getDataCollectStatisticChart() {
      //获取采集故障
      if (this.eid == '' || this.eid == undefined) {
        return false
        //this.attributeId = "49"
      }
      if (this.attributeId == '' || this.attributeId == undefined) {
        return false
        //this.attributeId = "49"
      }
      if (this.form.length == 0) {
        this.$toaster.error('请至少选择一组环比时间段')
        return false
      } else {
        for (var i = 0; i < this.form.length; i++) {
          if (this.form[i].dateRange == '') {
            this.$toaster.error('请选择环比时间段')
            return false
          }
        }
      }
      var arrform = []
      for (var i = 0; i < this.form.length; i++) {
        var obj2 = {}
        obj2.startDate = this.$utils.zhDatetime(this.form[i].dateRange[0])
        obj2.endDate = this.$utils.zhDatetime(this.form[i].dateRange[1])
        arrform.push(obj2)
      }
      var obj = {
        attributeId: this.attributeId,
        dateTntervals: arrform,
        eid: this.eid,
        token: store.state.user.token
      }
      this.dateType = undefined
      this.$api.device.getChainAnalysisChart(obj).then(res => {
        if (res.code == 200) {
          // if (this.currentPage != 1 && res.data.length == 0) {
          //   this.currentPage = this.currentPage - 1;
          //   this.getIotRealDat();
          // } else {
          //   this.total = res.pageInfo.total;
          //   this.tablelist = res.data;
          // }

          var datax = []
          var datayy = []
          var color = ['#0356FE', '#eb2d08', '#00ff00', '#ff00ff']

          for (var j = 0; j < res.data.xTimes.length; j++) {
            datax.push(res.data.xTimes[j])
          }
          var title = []
          for (var i = 0; i < res.data.yDatas.length; i++) {
            //这层遍历出几个属性
            var datay = []

            for (var k = 0; k < res.data.yDatas[i].datas.length; k++) {
              //这层遍历出该属性下的所有点的数据
              datay.push(parseFloat(res.data.yDatas[i].datas[k].value).toFixed(2))
            }
            title.push(res.data.yDatas[i].dateTnterval)
            var obj = {
              name: res.data.yDatas[i].dateTnterval,
              data: datay,
              type: 'line',
              smooth: true,
              symbolSize: 0,
              itemStyle: {
                normal: {
                  // color:'#0356FE',
                  color: color[i],
                  lineStyle: {
                    //color:'#0356FE'
                    color: color[i]
                  }
                }
              },
              areaStyle: {
                // normal:{
                //    //  color:"#d2e9ef"
                //     color:color2[i],
                // }
              } //区域颜色渐变
            }
            datayy.push(obj)
          }

          this.drawLine(datax, datayy, title)
          this.isloading = false
        }
      })
    },

    drawLine(datax, datayy, title) {
      this.$forceUpdate()
      var myChart = document.getElementById('myChart7')
      var chartObj = echarts.init(myChart)
      chartObj.resize()
      chartObj.clear()
      chartObj.setOption({
        tooltip: {
          trigger: 'axis',
          position: function (point, params, dom, rect, size) {
            // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
            // 提示框位置
            var x = 0 // x坐标位置
            var y = 0 // y坐标位置

            // 当前鼠标位置
            var pointX = point[0]
            var pointY = point[1]
            // 提示框大小
            var boxWidth = size.contentSize[0]
            var boxHeight = size.contentSize[1]
            // boxWidth > pointX 说明鼠标左边放不下提示框
            if (boxWidth > pointX) {
              x = 5
            } else {
              // 左边放的下
              x = pointX - boxWidth
            }
            // boxHeight > pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5
            } else {
              // 上边放得下
              y = pointY - boxHeight
            }

            return [x, y]
          }
        },
        legend: {
          data: title,
          top: 20
        },
        grid: {
          top: 60,
          left: 60,
          right: 100,
          bottom: 50
        },
        xAxis: {
          name: '',
          nameTextStyle: {
            color: '#c1c1c1',
            padding: [46, 5, 5, 48],
            fontSize: 12
          },
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: '#EBEEF5'
            }
          },
          axisLabel: {
            textStyle: {
              color: '#c1c1c1',
              fontSize: 10
            },
            margin: 16 //刻度标签与轴线之间的距离。
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#EBEEF5'],
              width: 1,
              type: 'solid'
            }
          },
          data: datax //['17:22:00', '17:24:00', '17:26:00', '17:28:00', '17:30:00', '17:32:00', '17:34:00', '17:36:00', '17:38:00', '17:40:00', '17:42:00']
        },
        yAxis: {
          name: '数值',
          nameTextStyle: {
            color: '#54627D',
            //align:"right",
            padding: [80, 5, 10, -20],
            fontSize: 12
          },
          axisLine: {
            lineStyle: {
              color: '#EBEEF5'
            }
          },
          axisLabel: {
            textStyle: {
              color: '#54627D',
              fontSize: 10
            },
            margin: 20 //刻度标签与轴线之间的距离。
          },
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#EBEEF5'],
              width: 1,
              type: 'solid'
            }
          }
        },
        series: datayy
        //  [{
        //   data: datax,//[820, 932, 901, 934, 1290, 1130, 1020, 1120, 1340, 1220, 1520],
        //   type: 'line',
        //   smooth: true,
        //   symbolSize: 0,
        //   itemStyle : {
        //     normal : {
        //       color:'#0356FE',
        //       lineStyle:{
        //         color:'#0356FE'
        //       }
        //     }
        //   },
        //  areaStyle:{
        //       normal:{
        //           color:"#d2e9ef"
        //       }
        //   },//区域颜色渐变

        // }]
      })
    },
    getNowdate() {
      var datee = new Date()
      var year = datee.getFullYear()
      var month = datee.getMonth()
      var day = datee.getDate()

      var Hours = datee.getHours() //得到小时

      this.form[0].dateRange = [new Date(year, month, day, Hours, 0, 0), new Date(year, month, day, Hours, 59, 59)]
    }
  },
  created() {
    this.usertypeshow = this.$utils.getStorage('userType')
  },
  mounted() {
    this.getNowdate()
    // this.getAlarmChart()
    // this.drawbarchart()
  },
  activated: {},
  watch: {
    decisionId() {
      this.getDevicesByGroupId()
    },
    groupId(val) {
      this.attributeId = ''
      this.attrList = []
      this.getDevicesByGroupId(val)
      this.serchKey()
    },
    eid(val) {
      this.serchKey()
      this.getRealDatasByEid(val)
    },
    attributeId(val) {
      this.serchKey()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.sc-btn2 {
  color: red;
  position: absolute;
  top: -4px;
  right: 50px;
  cursor: pointer;
}
.search-box {
  display: flex;
}
.title {
  font-size: 14px;
  color: #647189;
  margin-left: 20px;
}
.realtimeDataChart {
  width: 100%;
  height: 600px;
}
.realtimeDataChart-body {
  width: 100%;
  height: 100%;
}
</style>
